import { HtsReadinessPillarKey } from "../constants";
import { HtsReadinessPillarConfig } from "../schemas";

export const lifeSkills: HtsReadinessPillarConfig = {
  key: HtsReadinessPillarKey.LIFE_SKILLS,
  label: "Life Skills",
  definition:
    "The ability to manage adult responsibilities, which may include basic skills acquired through learning and direct life experience that enable a person to handle the issues of daily adult life. Living arrangement is not scored on its own — responsibility for household, financial, and personal obligations is scored regardless of who else lives in the home.",
  dataSourceNote:
    "Derived — housing (Section A), employment and education details including the education-funding field (Section C). Nothing asked twice.",
  dimensions: [
    {
      key: "independentLiving",
      label: "Independent Living",
      weight: 0.35,
      anchors: {
        0: "No household or personal-administration responsibilities of their own, regardless of living arrangement.",
        25: "Minimal responsibility: occasional contribution, no financial or administrative obligations carried alone.",
        50: "Carries one responsibility alone (own bills and admin, or a regular financial contribution to housing, or transportation), with the rest supported.",
        75: "Carries two responsibilities alone (for example, pays rent, board, or mortgage share, and manages own bills, insurance, and admin), with some support on the rest.",
        100: "Carries three or more responsibilities alone, or is responsible for dependents — in any living arrangement, including shared or multigenerational homes.",
      },
    },
    {
      key: "financialSelfSufficiency",
      label: "Financial Self-Sufficiency",
      weight: 0.35,
      anchors: {
        0: "No income; all expenses covered by others.",
        25: "Some income; the large majority of living expenses covered by others.",
        50: "Working and funding a meaningful share of own expenses.",
        75: "Funding most or all of own living costs for a sustained period while studying or working.",
        100: "Fully self-supporting; no financial dependence on others. Fully self-supporting for a sustained period (12+ months). Scholarship, employer, military, band, or family funding of tuition does not lower this score.",
      },
    },
    {
      key: "lifeManagementResponsibility",
      label: "Life Management & Responsibility",
      weight: 0.3,
      anchors: {
        0: "No evidence of managing competing responsibilities.",
        25: "Manages a single commitment (school or a job) with support from others.",
        50: "Balances two significant commitments (e.g., work and school) with occasional strain but no failures.",
        75: "Reliably balances multiple commitments (work, school, sport, volunteering) over a sustained period.",
        100: "Manages a full adult load — household, dependants or equivalent obligations, multiple commitments — with demonstrated reliability.",
      },
    },
  ],
  topIndicators: [
    "Self-supporting while working or studying",
    "Responsibility for a household or dependents in any living arrangement",
    "A sustained multi-commitment schedule handled without dropped balls",
  ],
  scoringNotes: [
    "Recreational video gaming is not competitive sport or structured training.",
    "Life Management & Responsibility is scored relative to years since age 18 — a candidate with two years of adult history is scored on those two years.",
    "The top rung (three or more household responsibilities carried alone, 12+ months self-supporting, a sustained multi-commitment load) should compute to roughly 90+; no responsibilities and no income should compute to under 15. Living arrangement, degree, and related work are not part of this calibration.",
  ],
};
